import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { IoClose } from "react-icons/io5";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import BlockUserList from "./BlockUserList";
import TextTranslate from "../../../utils/TextTranslate";

const BlockUserListModal: React.FC = () => {
  const ViewManager = useAppSelector((state) => state.ViewManager);
  const dispatch = useAppDispatch();

  const handleCloseModal = () => {
    dispatch(updateViewState({ showBlockUserList: false }));
  };

  return (
    <Dialog
      open={ViewManager.showBlockUserList}
      onClose={handleCloseModal}
      className="relative z-[100]"
    >
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm">
        <div className="flex min-h-full items-end justify-center p-0 sm:items-center sm:p-4">
          <DialogPanel className="relative flex max-h-[85dvh] w-full max-w-md flex-col overflow-hidden rounded-t-[1.25rem] bg-primary shadow-2xl sm:rounded-2xl">
            <DialogTitle className="shrink-0 border-b border-black/[0.06] bg-primary/90 px-3 py-3 backdrop-blur-xl dark:border-white/[0.08]">
              <div className="flex items-center justify-between">
                <button
                  type="button"
                  aria-label="Close"
                  onClick={handleCloseModal}
                  className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
                >
                  <IoClose className="text-xl" />
                </button>
                <span className="text-[17px] font-semibold tracking-tight text-darkText">
                  <TextTranslate text="Blocked account" />
                </span>
                <div className="h-9 w-9" aria-hidden />
              </div>
            </DialogTitle>

            <div className="min-h-0 flex-1 overflow-hidden">
              <BlockUserList />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default BlockUserListModal;
